// Internal test user configuration
// These emails will see the site as fully paid users without real payments
// ONLY on lovable.app preview domains, never on production

export const TEST_USER_EMAILS = ['elhunterlegacy@gmail.com'];

export function isTestUser(email?: string | null): boolean {
  if (!email) return false;
  
  // Only allow test mode on lovable.app preview domains
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (!hostname.includes('lovable.app')) {
      return false;
    }
  } else {
    // SSR or non-browser environment - disable test mode
    return false;
  }
  
  return TEST_USER_EMAILS.includes(email.toLowerCase());
}
